import template from './order-details.html';

export default {
  controller: 'OrderDetailsController',
  template,
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/order-details/order-details.component.js